module.exports = __webpack_public_path__ + "img/video-homepage.69bb057a.png";